module.exports = __webpack_public_path__ + "static/media/pic4.54b7183b.webp";